// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iScrollVerticalScrollbar.iScrollLoneScrollbar{z-index:1!important}.feedback{display:flex;justify-content:center}.web__msg--file,.web__msg--img,.web__msg--video{position:relative;max-width:250px;min-width:200px;width:100%;margin:10px 0;border:1px solid #eee;overflow:scroll;border-radius:5px;cursor:pointer;display:block}.web__msg--img[data-class=iconBox]{max-width:24px;min-width:unset;border:none;margin:0;vertical-align:bottom;display:inline-block}", ""]);
// Exports
module.exports = exports;
